import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(response => { // 拉取user_info
        // const data = response.result
          store.dispatch('GenerateRoutes').then(() => { // 生成可访问的路由表
            console.log('p', store.getters.addRouters)
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a history record
          }).catch((err) => {
            console.log('err', err)
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          })
        })
      } else {
        next()
      }

      // next()
      // let tempToken = JSON.parse(getToken()).token;

      // store.dispatch('CheckToken', tempToken).then(res => { // 拉取user_info
      //   next()
      // }).catch(() => {
      //   store.dispatch('FedLogOut').then(() => {
      //     Message.error('验证失败,请重新登录0')
      //     next({ path: '/login' })
      //   })
      // })
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js